// similar to RequireAuth functionality -- this redirects away from 
// the encompassed route if the validation fails

import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from 'react-redux'
import { isAdminUser } from '../utils/isAdminUser'

// RequireAdmin restricts admin pages to users with the Firebase admin claim
function RequireAdmin({ children }) {
  const location = useLocation();
  const userLogin = useSelector((state) => state.userLogin)
  const {userInfo} = userLogin

  // redirect to homepage if user is not admin
  if (!isAdminUser(userInfo)) {
    return (
      <Navigate to="/homepage" replace state={{ from: location.pathname }} />
    );
  }

  return children;
}

export default RequireAdmin;
